export default "__VITE_ASSET__feqzrfeb__"